module.exports = new __parcel__URL__("assign_points_button.a3457874.png").toString();